import * as React from 'react';

import logger from 'js/app/loggerSingleton';
import { useLocation } from 'js/lib/useRouter';

import ValuePropositionComponent from 'bundles/browse-common/components/ValuePropositionComponent';
import { usePageConfigComponentMetadata } from 'bundles/page-config-common/contexts/PageConfigComponentMetadataContext';
import useFacetCounts from 'bundles/search-common/hooks/useFacetCounts';
import { inferQueryFromParams } from 'bundles/search-common/utils/eventingUtils';
import { FREE_QUERY_PLACEHOLDER_ADDITIONAL_CONTENT } from 'bundles/search-common/utils/pageConfigUtils';
import { useSeoPageData } from 'bundles/seo/contexts/SeoPageDataContext';

import _t from 'i18n!nls/search-common';

type AdditionalContentProp = {
  freeCount: number;
  freeTrialCount: number;
};
const getAdditionalContent = ({ freeCount, freeTrialCount }: AdditionalContentProp) => {
  return [
    {
      value: freeCount,
      category: _t('free courses'),
    },
    {
      value: freeTrialCount,
      category: _t('courses with a free trial'),
    },
  ];
};

const FreeQueryValuePropositionRenderer = () => {
  const context = usePageConfigComponentMetadata();
  const query = inferQueryFromParams(useLocation().query.query);
  const { eqpData } = useSeoPageData();
  const title = eqpData?.topContentBlock?.label || _t('Results for "#{query}"', { query });
  const description = eqpData?.topContentBlock?.content;

  const {
    freeCount,
    freeTrialCount,
    isLoading: loadingAdditionalContent,
  } = useFacetCounts('cost', {
    freeCount: 'Free',
    freeTrialCount: 'Free Trial',
  });
  const additionalContent = getAdditionalContent({ freeCount, freeTrialCount });

  if (!context) {
    logger.warn('FreeQueryValuePropositionRenderer expected PageConfigComponentMetadataProvider');
    return null;
  }

  const { index } = context;

  return (
    <ValuePropositionComponent
      showPageTitleHeadingSize={index === 0}
      title={title}
      description={description}
      additionalContent={loadingAdditionalContent ? FREE_QUERY_PLACEHOLDER_ADDITIONAL_CONTENT : additionalContent}
      isLoading={loadingAdditionalContent}
    />
  );
};

export default FreeQueryValuePropositionRenderer;
